<script>
import forminput from "@/router/views/FormComponet/forminput.vue";
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import formtreeselect from "@/router/views/FormComponet/formtreeselect.vue";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrBirimButceHarcamalariTutarlari from "@/models/StrBirimButceHarcamalariTutarlari";
import StrOkasKodlari from "./StrOkasKodlari"
const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [Api, Sabit, StrBirimButceHarcamalariTutarlari],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      hesapkodlari:[],
      okaskodlari:[],
      Strperformanshedefiid: "",
      Strtabdetfaaliyetid: "",
      options:{}
    };
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    formtreeselect,
    StrOkasKodlari,
    Treeselect
  },
  watch: {
    Id() {
      
    //  this.liste_kontrol();
      this.FormData = this.Id;

      if(this.FormData.Okaskoduid){
        this.FormDataType.Okaskoduid.ComboDataArray=[]
        this.FormDataType.Okaskoduid.ComboDataArray.push ( { id: this.FormData.Okaskoduid, label: this.FormData.OkasKodAciklama})
      }
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.FormData.Tutar =
        parseFloat(this.FormData.Kdvsiz) + parseFloat(this.FormData.Kdv);
        this.FormData.Kdv = parseFloat(this.FormData.Kdv);
        this.FormData.Kdvsiz = parseFloat(this.FormData.Kdvsiz);
        this.FormData.Adet = parseFloat(this.FormData.Adet);
        this.FormData.Birimfiyat = parseFloat(this.FormData.Birimfiyat);
         // parseInt(this.FormData.Kdvsiz) + parseInt(this.FormData.Kdv);

        if (this.AddEdit == "Add") {
          this.Post("StrBirimButceHarcamalariTutarlari", this.FormData).then(
            (res) => {
              if (res) {
          this.$bvModal.hide("StrBirimButceHarcamalariTutarlari");
          this.$emit("TableUpdate");
              }
            });
        } else {
          this.FormData.Tutar =
        parseFloat(this.FormData.Kdvsiz) + parseFloat(this.FormData.Kdv);
        this.FormData.Kdv = parseFloat(this.FormData.Kdv);
        this.FormData.Kdvsiz = parseFloat(this.FormData.Kdvsiz);
        this.FormData.Adet = parseFloat(this.FormData.Adet);
          this.Update("StrBirimButceHarcamalariTutarlari", this.FormData).then(
            (res) => {
              if (res) {
                this.$emit("TableUpdate", this.FormData);
                this.$bvModal.hide("StrBirimButceHarcamalariTutarlari");
              }
            }
          );
        }
      }
    },
    Get() {},
    
    loadOptions({ action,  callback }) {
      this.options=[];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

           this.options = this.hesapkodlari;

          callback(null, this.options)
        })
      }
    },

    okas_loadOptions({ action,  callback }) {
      this.options=[];
      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {

           this.options = this.okaskodlari;

          callback(null, this.options)
        })
      }
    },

    liste_yukle(veri){
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };

      if (veri.length>=1){

          this.hesapkodlari=[];

          let Filter ="";
          if(veri[0]=="0" && veri[2]=="."){
            Filter = "&Basamak=4&KodForLike="+veri;
          } else {
          
          Filter = "&Basamak=4&Aciklama="+veri;
          }

          this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {  
            for(var i=0; i<res.Data.length; i++)
              {
                this.hesapkodlari.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " - " + res.Data[i].Aciklama})
              }    
          }); 

      }

    },

    okas_liste_yukle(veri){
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };

      if (veri.length>=1){

          this.okaskodlari=[];

          this.ActionsFilterGet({
          Service: "StrOkasKodlari",
          Page: Page,
          Filter: "&KodOrAciklama=" + veri,
          }).then((res) => {
            for(var i=0; i<res.Data.length; i++)
              {
                this.okaskodlari.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " - " + res.Data[i].Aciklama})
              }
          }); 

      }

    },

    liste_kontrol(){
    
        if(this.AddEdit=="Edit"){
          this.hesapkodlari=[];
          this.options=[];
         
            this.hesapkodlari.push ({"id":this.Id.Hesapkodlariid,"label": this.Id.HesapKodAciklama})

            this.options=this.hesapkodlari;

        /*    this.loadOptions({
              action: ASYNC_SEARCH,
                  callback: (error, options) => {
                      if (error) {
                        console.error(error)
                      } else {
                        console.log(options)
                      }
                  }
            });     */ 

        }

    }

  },
  created(){
    this.liste_kontrol();
  }
};
</script>
<template>
  <Loader>
    <b-modal centered
      id="StrBirimButceHarcamalariTutarlari"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrBirimButceHarcamalariTutarlari.AddEdit.FormTitleEdit')
          : $t('StrBirimButceHarcamalariTutarlari.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    > 
      <Form @submit.prevent="onSubmit">

        
        <div class="row">
          <div class="col-md-6">           
            <formtreeselect
              v-if="AddEdit=='Edit'"
              :name="'Hesapkodlariid'"
              :FormDataType="FormDataType.Hesapkodlariid"
              :Value="FormData.Hesapkodlariid"
              :v="$v.FormData.Hesapkodlariid"
              @input="FormData.Hesapkodlariid = $event"
            />

            <b-form-group class="mb-3" id="example text"  label="Tertibi" label-for="text">
        
                <treeselect 
                v-if="AddEdit=='Add'"
                name="'cbhesapkodlari'"
                id="'cbhesapkodlari'"
                @search-change="liste_yukle($event)"
                :async="true"
                :load-options="loadOptions"
                :options="FormDataType.Hesapkodlariid.ComboDataArray"
                :multiple="false"   
                searchPromptText="Aramak için yazın..."
                placeholder="Seçiniz..." 
                v-model="FormData.Hesapkodlariid"          
                />

                <treeselect-value :value="FormData.Hesapkodlariid" />
            </b-form-group>


          </div>
          <div class="col-md-6">
           

           <!--
            <formtreeselect
            :name="'Okaskoduid'"
              :FormDataType="FormDataType.Okaskoduid"
              :Value="FormData.Okaskoduid"
              :v="$v.FormData.Okaskoduid"
              @input="FormData.Okaskoduid = $event"
            /> -->

            <b-form-group class="mb-3" id="example text"  label="Okas Kodları" label-for="text">
        
                <treeselect 
                v-if="AddEdit=='Add'"
                name="'okaskodlari'"
                id="'okaskodlari'"
                @search-change="okas_liste_yukle($event)"
                :async="true"
                :load-options="okas_loadOptions"
                :options="FormDataType.Okaskoduid"
                :multiple="false"   
                searchPromptText="Aramak için yazın..."
                placeholder="Seçiniz..." 
                v-model="FormData.Okaskoduid"          
                />

                <treeselect-value :value="FormData.Okaskoduid" />
            </b-form-group>
          
          
          
       
            
        <!-- <div class="col-md-1">
                  <i
                    class="fas fa-eye"
                    v-b-modal.StrOkasKodlari
                    
                  ></i>
                </div>
          --> 

          
          </div>
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Iskalemadi"
              :Value="FormData.Iskalemadi"
              :v="$v.FormData.Iskalemadi"
              @input="FormData.Iskalemadi = $event"
            />
          </div>
          <div class="col-md-6">
            <formcombobox
              :FormDataType="FormDataType.Olcubirimiid"
              :Value="FormData.Olcubirimiid"
              :v="$v.FormData.Olcubirimiid"
              @input="FormData.Olcubirimiid = $event"
            />
          </div>
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Adet"
              :Value="FormData.Adet"
              :v="$v.FormData.Adet"
              @input="FormData.Adet = $event"
            />
          </div>
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Birimfiyat"
              :Value="FormData.Birimfiyat"
              :v="$v.FormData.Birimfiyat"
              @input="FormData.Birimfiyat = $event"
              :min="0"
              :step="0.01"
            />
          </div>
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Kdvsiz"
              :Value="FormData.Kdvsiz"
              :v="$v.FormData.Kdvsiz"
              @input="FormData.Kdvsiz = $event"
              :min="0"
              :step="0.01"
            />
          </div>
          <div class="col-md-6">
            <forminput
              :FormDataType="FormDataType.Kdv"
              :Value="FormData.Kdv"
              :v="$v.FormData.Kdv"
              @input="FormData.Kdv = $event"
              :min="0"
              :step="0.01"
            />
          </div>

        </div>
        <button class="btn btn-primary" type="submit">
          {{ $t("StrBirimButceHarcamalariTutarlari.AddEdit.Button") }}
        </button>
      </Form> 
    </b-modal>
    <StrOkasKodlari @Data="
    (FormData.Okaskoduid = $event.Id),
    (FormDataType.Okaskoduid.ComboDataArray=[]),
    (FormDataType.Okaskoduid.ComboDataArray.push ( { id: $event.Id, label: $event.Aciklama})) 
    "/>
  </Loader>
</template>
